export enum COLORS {
  GREEN = 'green',
  GREY = 'grey',
}
